<template>
	<div class='box' style="width: 1200px; margin: auto" v-loading="loading" element-loading-text="拼命加载中"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 面包屑导航 -->
		<el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right" v-if="breadcrumbList">
			<!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>限时折扣</el-breadcrumb-item> -->
			<el-breadcrumb-item style="cursor: pointer" @click.native="breadcrumbClick(item.id, index, item)"
				v-for="(item, index) in breadcrumbList" :key="item.id">{{ item.name }}</el-breadcrumb-item>
			<el-breadcrumb-item v-if="breadcrumbList.length == 1 ? true : false">所有</el-breadcrumb-item>
		</el-breadcrumb>
		<div class='tips'>
			<div>
				<p>温馨提示</p>
				<div>1.直接填写商品编码或物料号，系统自动识别关联出商品，分别输入购买数量后可点击加入采购单/立即下单;</div>
				<div>2.支持excel模板批量导入，下载模板填与商品编码或物料号(二选一)、输入购买数量后上传清单，系统自动批量识别关联出商品;</div>
				<div>3.查找不到商品请联系<span class="goService">客服</span>;</div>
			</div>
			<div class="btnList">
				<div class='excalButtom'>
					<a href="./static/exportQuickOrder.xlsx" style="color:#fff" download="快速下单模板"
						target="downloadFile">Excel清单模板下载</a>
				</div>
				<div class='excalButtom' @click="getExcel">
					Excel清单上传
				</div>
			</div>

		</div>

		<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%">
				<el-table-column label="序号" width="80" align='center'>
					<template slot-scope="scope">
						<el-checkbox :label="scope.row.code" :key="scope.row.code">{{ scope.$index }}</el-checkbox>
					</template>
				</el-table-column>

				<el-table-column label="商品名称" width="300" align="center">
					<template slot-scope="scope">
						<div class='shopName'>
							<img :src="scope.row.logoUrl" alt="" v-if="scope.row.logoUrl">
							<el-input :disabled='scope.row.isHidden' @change="changeList(scope.$index)"
								v-model="scope.row.name" placeholder="请输入内容">
							</el-input>
							<!-- <div>{{ scope.row.name }}</div> -->
							<div class="moreBn" v-if="scope.row.total>1" @click="selectBn(scope.$index)">
								找到：{{scope.row.total}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品编码" width="120" align='center'>
					<template slot-scope="scope">
						<!-- <el-input :disabled='scope.row.isHidden' @change="changeList(scope.$index)" v-model="scope.row.code"
				      placeholder="请输入内容">
				    </el-input> -->
						<div>{{ scope.row.code }}</div>
						<div v-if="scope.row.unknown&&scope.row.goodsList.length<1" style="font-size: 12px;">
							未查询到商品信息,联系平台<span>客服</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="商品规格" width="200" align="center">
					<template slot-scope="scope">
						<div class='shopName' style="justify-content: center"
							v-if="scope.row.specificationlist.length>0">
							<el-dropdown @command="handleCommand">
								<span class="el-dropdown-link" :data-id="scope.row">
									{{scope.row.bxysName?scope.row.bxysName:"请选择商品规格"}}<i
										class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown" class="dropdownBox">
									<el-dropdown-item :command="{value:item.id,code:scope.row.code,data:item}"
										v-for="item in scope.row.specificationlist" :key="item.id">{{item.attributeContent}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</template>
				</el-table-column>


				<el-table-column label="店铺" width="150" align="center">
					<template slot-scope="scope">
						<div class='shopName' v-if="scope.row.merchantName">
							<div>{{ scope.row.merchantName }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="库存" width="80" align='center'>
					<template slot-scope="scope">{{ scope.row.stock }}</template>
				</el-table-column>
				<el-table-column label="单价" width="80" align='center'>
					<template slot-scope="scope">
						<div v-if="scope.row.price">￥{{ Number(scope.row.price).toFixed(2) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="数量" width="120" align='center'>
					<template slot-scope="scope">
						<div v-if="scope.row.isHidden">
							<el-input-number size="mini" v-model="scope.row.num" @change="handleChange" :min="1" :max="scope.row.stock"
								label="描述文字"></el-input-number>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="小计" width="100" align='center'>
					<template slot-scope="scope">
						<div v-if="scope.row.price">￥{{ (Number(scope.row.price) * Number(scope.row.num)).toFixed(2) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100" align='center'>
					<template slot-scope="scope">
						<div class="remove" @click="removeList(scope.$index)">删除</div>
					</template>
				</el-table-column>
			</el-table>
		</el-checkbox-group>
		<div class="checkedAll">
			<div class='all_left'>
				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
				</el-checkbox>
				<div class='removeShop' @click="removeShop">- 删除选择商品</div>
				<div class='addShop' @click="addShop">+ 继续添加商品</div>
			</div>
			<div class="all_right">
				<div class='allPrice'>总价(不含运费)：<span>￥{{ priceTotal||0 }}</span></div>
				<div class="rightButtom addPurchase" @click="shoppingCart">加入采购单</div>
				<div class="rightButtom" @click="BuyNow()">立即购买</div>
			</div>
		</div>
		<div>
			<import-excel ref="importExcel" @getResult="getMyExcelData" />
		</div>

		<div>
		</div>

		<!-- 商品选择框 -->
		<el-dialog title="选择商品" id="pagesRow" :visible.sync="centerDialogVisible" width="40%" center>
			<span style="font-size: 16px;line-height: 28px;">查找到{{selectList.length}}条商品信息，请选择</span>
			<ul class="pupGoodsList">
				<li class="goodsSon" v-for="(item , index) in selectList" :key="index">
					<input type="radio" name="goods" @click="radioBn(index)" />
					<span>{{item.name}}</span>
				</li>
			</ul>
			<div id="pagesbox"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>


	</div>
</template>
<script>
	let arr = 0
	import importExcel from "@/components/excel";
	import {
		shoppingCartlist,
		ModuleGet,
		shoppingCart,
		quicklyModuleGet
	} from "@/api/xunyou";
	import {
		log
	} from "async";
	export default {
		props: {
			breadcrumbList: {
				type: Array,
				default: function() {
					return [{
							id: 1,
							name: "首页",
							url: "/"
						},
						{
							id: 0,
							name: "所有",
							url: "/limitDiscounts"
						},
					]
				}
			}
		},
		data() {
			return {
				adv: '123132',
				num: 1,
				list: '',
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				checkAll: false,
				checkedCities: [],
				isIndeterminate: true,
				allSelect: [],
				loading: false,
				tableData: [
					//     {
					//     code: '048004',
					//     name: '赫力斯HELISI沾墅活扳手活动扳手150mm(6"")021106',
					//     address: '上海市普陀区金沙江路 1518 弄',
					//     id: 1,
					//     stock: '1天',
					//     price: '18.9',
					//     num: 2,
					//     logoUrl: 'https://520cy.cn/shopping/h5/static/icon/index_coupon.png',
					//     isHidden: true,
					// }, {
					//     code: '11338812',
					//     name: '赫力斯HELISI沾墅活扳手活动扳手150mm(6"")021106',
					//     address: '上海市普陀区金沙江路 1518 弄',
					//     id: 2,
					//     stock: '1天',
					//     price: '20.9',
					//     num: 1,
					//     logoUrl: 'https://520cy.cn/shopping/h5/static/icon/index_coupon.png',
					//     isHidden: true,
					// }, {
					//     code: '10308575',
					//     name: '赫力斯HELISI沾墅活扳手活动扳手150mm(6"")021106',
					//     address: '上海市普陀区金沙江路 1518 弄',
					//     id: 3,
					//     stock: '1天',
					//     price: '21.9',
					//     num: 2,
					//     logoUrl: 'https://520cy.cn/shopping/h5/static/icon/index_coupon.png',
					//     isHidden: true,
					// },
				],
				multipleSelection: [],
				priceTotal: 0,

				goodsList: [], //商品list
				ruleForm: {
					muid: '',
					recipient: '',
					phoneNumber: '',
					areaid: '',
					address: '',
					postalCode: '',
					defaultAddress: 0,
				},
				centerDialogVisible: false, //商品弹窗
				selectList: [],
				selectListIndex: '', //选择商品的角标
				currPage: 1,
				pageSize: 10

			};
		},
		// 注册组件
		components: {
			importExcel
		},
		created() {
			// this.addList()
			// this.getList()
			if (this.userInfo.userId && JSON.parse(localStorage.getItem("userdata")).userId) {
				this.ruleForm.muid = JSON.parse(localStorage.getItem("userdata")).userId
			}

		},
		mounted() {
			// this.allPrice()
		},
		methods: {
			// 分页
			paged(e) {
				let that = this;
				layui.use(['laypage', 'layer'], function() {
					var laypage = layui.laypage
					laypage.render({
						elem: 'pagesbox', // 分页容器id
						count: e.total, //总页数
						limit: this.pageSize, //每页显示的数量
						curr: e.pageValue, //当前页
						layout: ['prev', 'page', 'count', 'next', 'skip'], //设置分页显示的内容
						jump: function(obj, first) {
							//首次不执行
							if (!first) {
								console.log(obj.curr)
								e.pageValue = obj.curr;
								that.getPageList(e)
							}
						}
					});
				});

			},
			// 下拉
			handleCommand(command) {
				// this.$message('click on item ' + command.code);
				for (var a = 0; a < this.tableData.length; a++) {
					if (this.tableData[a].code == command.code) {
						console.log("相等");
						this.tableData[a].bxysid = command.value;
						this.$set(this.tableData[a], 'bxysName', command.data.attributeContent)
						this.$set(this.tableData[a], 'price', command.data.price)
						this.$set(this.tableData[a], 'realprice', command.data.price)
						this.$set(this.tableData[a], 'stock', command.data.stock)
						console.log(this.tableData[a]);
					}
				}
				console.log(this.tableData);
				this.allPrice()
			},
			// 面包屑点击事件
			breadcrumbClick(id, index, item) {
				if (id == 1) {
					// 说明是首页 文字
					this.$router.push("/");
				}
			},
			getList() {
				getExcel(res => {
					console.log(res)
				})
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.allSelect.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.allSelect.length;

				this.allPrice()
			},
			addList() {
				this.allSelect = []
				this.tableData.forEach(item => {
					this.allSelect.push(item.code)
				});
			},
			handleCheckAllChange(val) {
				console.log('---4');
				this.checkedCities = val ? this.allSelect : []
				this.isIndeterminate = false;
				this.allPrice()
			},
			addShop() {
				if (this.tableData.length == 0 || this.tableData[this.tableData.length - 1].isHidden) {
					this.tableData.push({
						code: '',
						name: '',
						address: '',
						id: arr++,
						stock: '',
						price: '',
						num: '',
						logoUrl: '',
						isHidden: false,
						cid: '',
						uid: '',
						bxysid: '',
						merchantName: '',
						specificationlist: [],
						bxysName: '',
						bxmId: '',
						goodsList: [],
						unknown: false
					})
					this.addList()





				} else {
					this.$message({
						message: '请输入内容',
						type: 'warning'
					});
				}
			},
			removeList(val) {
				this.tableData.splice(val, 1)
				this.allPrice()
			},
			handleChange() {
				this.allPrice()
			},

			radioBn(index) { //选中之后重新赋值
				const arr = {
					id: this.tableData[this.selectListIndex].id,
					code: this.selectList[index].id,
					name: this.selectList[index].name,
					stock: this.selectList[index].stock,
					price: this.selectList[index].specificationlist[0].price || this.selectList[index]
						.price, //不存在规格时执行
					realprice: this.selectList[index].specificationlist[0].price || this.selectList[index].price,
					num: 1,
					logoUrl: this.selectList[index].more_photos.split(',')[0],
					photos: this.selectList[index].more_photos.split(',')[0],
					cid: this.selectList[index].cid,
					uid: this.selectList[index].uid,
					bxysid: this.selectList[index].specificationlist[0].id || '', //默认第一个规格
					bxysName: this.selectList[index].specificationlist[0].attributeContent || '', //默认第一个规格
					stock: this.selectList[index].specificationlist[0].stock || '', //默认第一个规格
					merchantName: this.selectList[index].merchantName,
					isHidden: true,
					goodsId: this.selectList[index].id,
					specificationlist: this.selectList[index].specificationlist,
					bxmId: this.selectList[index].mid,
					goodsList: [], //相似商品
					unknown: false
				}
				this.$set(this.tableData, this.selectListIndex, arr)
				this.centerDialogVisible = false;

				// // 调试完删除
				// this.centerDialogVisible = true;
				// this.selectList = this.tableData[index].goodsList;

			},
			selectBn(index,type,data) { //选择商品
			if(type ==2){
				this.centerDialogVisible = true;
				this.selectList = data;
				this.selectListIndex = index;
				this.paged(this.tableData[index])
			}else{
				console.log(this.tableData[index]);
				console.log(this.tableData[index].goodsList);
				this.centerDialogVisible = true;
				this.selectList = this.tableData[index].goodsList;
				this.selectListIndex = index;
				this.paged(this.tableData[index])
			}
				
			},
			// 点击分页获取内容
			getPageList(e) {
				let obj = {
					pageSize: this.pageSize,
					name: e.antistop,
					pageNum: e.pageValue,
					userId: this.userInfo.userId || ''
				};
				this.selectList= [];
				layer.load('加载中', {time: 5*1000})
				quicklyModuleGet(obj).then(res => {
					layer.close(layer.index)
					if (res.rows[0]) {
						this.selectList = res.rows;
					} else {
						this.$message({
							message: '请确认商品名称是否正确',
							type: 'warning'
						});

						const arr = {
							code: '',
							name: '',
							address: '',
							id: this.tableData[index].id,
							stock: '',
							price: '',
							num: '',
							logoUrl: '',
							isHidden: false,
							cid: '',
							uid: '',
							bxysid: '',
							merchantName: '',
							specificationlist: [],
							bxysName: '',
							bxmId: '',
							goodsList: [],
							unknown: true //未找到商品
						}
						this.$set(this.tableData, index, arr)
					}
				})
			},
			changeList(index, e) { //模糊查询商品名称
				if (this.tableData[index].isHidden) { //已经查找过数据，重复查找会清空商品选项
					return false;
				}
				let obj = {
					pageSize: this.pageSize,
					name: this.tableData[index].name,
					pageNum: 1,
					userId: this.userInfo.userId || ''
				};
				console.log(obj);
				quicklyModuleGet(obj).then(res => {
					if (res.rows[0]) {
						let newArr = false;
						newArr = this.tableData.findIndex(item => item.code == res.rows[0].id)
						// if (this.tableData[newArr].isHidden) {
					// 	if (newArr > -1) {
					// 		this.$message({
					// 			message: '已存在商品，数量+1',
					// 			type: 'warning'
					// 		});
					// 		this.tableData[newArr].num++
					// 		this.tableData.splice(this.tableData.length - 1, 1)
					if(res.rows.length ==1 ){
							console.log('图片2' + res.rows[0].more_photos.split(',')[0]);
							const arr = {
								id: this.tableData[index].id,
								code: res.rows[0].id,
								name: res.rows[0].name,
								stock: res.rows[0].stock,
								price: res.rows[0].specificationlist[0].price || res.rows[0].price, //不存在规格时执行
								realprice: res.rows[0].specificationlist[0].price || res.rows[0].price,
								num: 1,
								logoUrl: res.rows[0].more_photos.split(',')[0],
								photos: res.rows[0].more_photos.split(',')[0],
								cid: res.rows[0].cid,
								uid: res.rows[0].uid,
								bxysid: res.rows[0].specificationlist[0].id || '', //默认第一个规格
								bxysName: res.rows[0].specificationlist[0].attributeContent || '', //默认第一个规格
								stock: res.rows[0].specificationlist[0].stock || '', //默认第一个规格
								merchantName: res.rows[0].merchantName,
								isHidden: true,
								goodsId: res.rows[0].id,
								specificationlist: res.rows[0].specificationlist,
								bxmId: res.rows[0].mid,
								goodsList: res.rows, //相似商品
								unknown: false,
								total: res.total, //商品总数
								antistop: this.tableData[index].name, //查找关键词
								pageValue: this.currPage, //当前页
								pageCount: Math.ceil(res.total / this.pageSize) //总页数
								// ...res.rows[0],
							}
							console.log(arr);
							this.$set(this.tableData, index, arr)
							this.tableData[index].isHidden = true;
						}else{
							this.selectBn(index,2,res.rows)//去选择，接口存在多条数据直接选择
						}

						this.addList()
						this.allPrice()
					} else {
						this.$message({
							message: '请确认商品名称是否正确',
							type: 'warning'
						});

						const arr = {
							code: '',
							name: '',
							address: '',
							id: this.tableData[index].id,
							stock: '',
							price: '',
							num: '',
							logoUrl: '',
							isHidden: false,
							cid: '',
							uid: '',
							bxysid: '',
							merchantName: '',
							specificationlist: [],
							bxysName: '',
							bxmId: '',
							goodsList: [],
							unknown: true //未找到商品
						}
						console.log(arr)
						this.$set(this.tableData, index, arr)
					}
				})
			},
			removeShop() {
				this.checkedCities.forEach(res => {
					this.tableData.splice(this.tableData.findIndex(item => item.code == res), 1)
				})
				this.checkedCities = []
				this.allPrice()
			},
			allPrice() { //合计价格
				let price = 0
				console.log(this.checkedCities);
				this.checkedCities.forEach(res => {
					this.tableData.forEach(item => {
						if (item.code == res) {
							price += (Number(item.price) * Number(item.num))
						}
					})
				})
				this.priceTotal = price.toFixed(2)
			},
			shoppingCart() {
				if (this.checkedCities.length > 0) {
					this.loading = true
					let bXyShoppingCartDto = {
						bxyShoppingCartList: []
					}
					var lists = [];
					this.checkedCities.forEach(item => {
						let list = this.tableData.find(res => res.code == item)
						bXyShoppingCartDto.bxyShoppingCartList.push({
							cid: list.code ? list.code : '',
							number: list.num ? list.num : 0,
							bxysid: list.bxysid ? list.bxysid : 0,
							uid: this.ruleForm.muid
						})
					})

					const str = JSON.stringify(bXyShoppingCartDto);
					shoppingCart({
						bXyShoppingCartDto: JSON.parse(JSON.stringify(str))
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '加入采购单成功',
								type: 'success'
							});
							this.getshoppingCartlist()
							this.loading = false
						}
					})
				} else {
					this.$message({
						message: '请选择商品',
						type: 'warning'
					});
				}
			},
			getshoppingCartlist() {
				shoppingCartlist({
						uid: this.userInfo.userId || ''
					})
					.then(res => {
						if (res.length > 0) {
							this.$store.commit('getCartList', res)
						}
					})
					.catch(err => {
						this.$message.error('购物车查询失败，请稍后再试！')
					})
			},
			getMyExcelData(data) {
				console.log(data);
				// data 为读取的excel数据，在这里进行处理该数据
				data.forEach(item => {
					let list = this.tableData.find(res => res.code == item.商品名称)
					if (list) {
						list.num++;
					} else {
						quicklyModuleGet({
							name: item.商品名称,
							pageSize: 50,
							pageNum: 1,
							userId: this.userInfo.userId || ''
						}).then(val => {
							console.log(val);
							// console.log(val.rows.length);
							if (val.rows.length < 1) {
								this.$message({
									message: '请确认商品名称是否正确',
									type: 'warning'
								});
								const arr = {
									code: '',
									name: '',
									address: '',
									id: this.tableData[index].id,
									stock: '',
									price: '',
									num: '',
									logoUrl: '',
									isHidden: false,
									cid: '',
									uid: '',
									bxysid: '',
									merchantName: '',
									specificationlist: [],
									bxysName: '',
									bxmId: '',
									goodsList: [],
									unknown: true //未找到商品
								}
								this.$set(this.tableData, index, arr)
								return false;
							}
							this.tableData.push({
								id: arr++,
								code: val.rows[0].id,
								name: val.rows[0].name,
								stock: val.rows[0].stock,
								price: val.rows[0].specificationlist[0].price || val.rows[0]
									.price, //不存在规格时执行2
								realprice: val.rows[0].specificationlist[0].price || val.rows[0]
									.price,
								num: 1,
								number: 0,
								logoUrl: val.rows[0].more_photos.split(',')[0],
								photos: val.rows[0].more_photos.split(',')[0],
								cid: val.rows[0].cid,
								uid: val.rows[0].uid,
								merchantName: val.rows[0].merchantName,
								bxmId: val.rows[0].mid,
								bxysid: val.rows[0].specificationlist[0].id || '', //默认第一个规格
								bxysName: val.rows[0].specificationlist[0].attributeContent || '',
								stock: val.rows[0].specificationlist[0].stock || '', //默认第一个规格
								isHidden: true,
								goodsId: val.rows[0].id,
								specificationlist: val.rows[0].specificationlist,
								bxysName: '',
								goodsList: val.rows //相似商品
							})
							this.addList()
						})
					}
				})
				// setTimeout(() => {

				//     this.addList()
				// }, 500);
			},
			getExcel() {
				this.$refs.importExcel.btnClick()
			},
			BuyNow() {
				console.log(this.checkedCities);
				console.log(this.tableData);
				this.goodsList = []
				this.checkedCities.forEach(res => {
					console.log("选中商品", this.checkedCities);
					this.tableData.forEach(item => {
						console.log(this.tableData);
						if (item.code == res) {

							console.log(item.code);

							let goodadata = item;
							// 规格id赋值
							goodadata.specificationlist = [{
								id: item.bxysid
							}]
							goodadata.cartSpecificationDetails = {
								attributeContent: item.bxysName,
								id: item.bxysid
							}


							goodadata.id = goodadata.code;
							goodadata.number = item.num;
							// 商品添加到同一家店铺
							let storeData = {}
							if (this.goodsList.length > 0) {
								for (let x = 0; x < this.goodsList.length; x++) {
									if (this.goodsList[x].bxmId == goodadata.bxmId) {
										this.goodsList[x].goods.push(goodadata)
										return false;
									}
								}
								// 不存在店铺
								storeData = {
									address: '',
									name: goodadata.merchantName,
									bxmId: goodadata.bxmId,
									goods: [],

								}
								storeData.goods.push(goodadata);
							} else {
								storeData = {
									address: '',
									name: goodadata.merchantName,
									bxmId: goodadata.bxmId,
									goods: []
								}
								storeData.goods.push(goodadata);

							}
							console.log("购买商品信息：", storeData);
							this.goodsList.push(storeData)
						}
					})
				})

				if (this.goodsList.length < 1) {
					this.$message({
						message: '请选择商品',
						type: 'warning'
					});
					return false;
				}
				console.log("goodsList", this.goodsList);
				sessionStorage.setItem("selectList", JSON.stringify(this.goodsList));
				this.$router.push('/orderDetail')
			}
		},
	};
</script>

<style scoped lang='less'>
	.box {
		width: 1200px;
		margin: 0 auto;

		.tips {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-bottom: 20px;
			color: gray;
			margin-top: 50px;

			.btnList {
				display: inline-block;
				width: 245px;

				.excalButtom {
					display: inline-block;
					padding: 5px 10px;
					color: #fff;
					background-color: #ff8000;
					cursor: pointer;
					margin-left: 10px;
					color: #fff;

					a {
						color: #ff8000;
					}
				}
			}

			.goService {
				color: red;
				cursor: pointer;
			}

		}
	}

	.shopName {
		display: flex;
		align-items: center;

		.moreBn {
			font-size: 12px;
			color: #ff8000;
			display: block;
			white-space: nowrap;
			padding-left: 3px;
			cursor: pointer;
		}

		div {
			text-align: left;
		}
	}

	/deep/ .el-input-number--mini {
		width: 100px;
	}

	.remove {
		padding: 5px 0px;
		border: 1px solid gainsboro;
		cursor: pointer;
	}

	.shopName {
		img {
			width: 40px;
			height: 40px;
			margin-right: 10px;
		}
	}

	.checkedAll {
		display: flex;
		justify-content: space-between;
		padding: 20px 12px 20px 46px;
		background: rgba(238, 238, 238);

		.all_left {
			display: flex;
			align-items: center;

			div {
				padding: 5px 10px;
				border: 1px solid gainsboro;
				background: #fff;
				cursor: pointer;
			}

			.removeShop {
				margin: 0 30px;
			}
		}

		.all_right {
			display: flex;
			align-items: center;

			.rightButtom {
				padding: 5px 10px;
				color: #fff;
				background: #ff8000;
				cursor: pointer;
			}

			.addPurchase {
				margin: 0 30px 0 50px;
			}

			.allPrice {
				color: #ff8000;

				span {
					font-size: 18px;
				}
			}
		}




	}

	.pupGoodsList {
		margin-top: 10px;
		height: 500px;
		overflow-y: scroll;

		.goodsSon {
			display: flex;
			align-items: flex-start;
			padding: 8px;
			border-bottom: 1px solid #ddd;
			background-color: #fff;

			input {
				display: inline-block;
				height: 22px;
				width: 22px;
				vertical-align: middle;
				margin: 0 3px;
				flex: 6;
				margin-top: 2px;
			}

			span {
				height: auto;
				font-size: 16px;
				line-height: 28px;
				vertical-align: middle;
				flex: 94;
			}
		}

		.goodsSon:nth-of-type(odd) {
			background-color: #f9f9f9;
		}
	}
	#pagesbox {
		height: 80px;
		width: 100%;
		text-align: center;
	}

	/deep/ .has-gutter {
		th {
			background-color: rgba(224, 224, 224);
		}
	}

	.dropdownBox {
		max-height: 700px;
		overflow-x: scroll;
	}
</style>


// WEBPACK FOOTER //
// src/views/quickly/index.vue